import { LogService } from "../../../../shared/services/log.service";
import { Validator } from "../../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../../ctrl.name.extractor";

export class CTRL_215 implements Validator {

    public static id = 'CTRL_215';
    private message = 'error.ctr_215';


    public LOG: LogService = new LogService(CTRL_215);

    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_215.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const servicesNameWithStepId = map.get(ctrl.value.rgCtrls.services);
                const servicesCtrl = form.controls[servicesNameWithStepId];

                if (servicesCtrl.value === 'services' || servicesCtrl.value === 'fournitures' || servicesCtrl.value === 'travaux') {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}